// Link to Segment Tracker
!function(){
    var analytics = window.analytics = window.analytics || [];
    if(!analytics.initialize) {
        if(analytics.invoked) {
            window.console&&console.error&&console.error("Segment snippet included twice.");
        } else {
            analytics.invoked = !0;
            analytics.methods = ["trackSubmit","trackClick","trackLink","trackForm","pageview","identify","reset","group","track","ready","alias","debug","page","once","off","on"];
            analytics.factory = function(t) {
                return function() {
                    var e = Array.prototype.slice.call(arguments);
                    e.unshift(t);
                    analytics.push(e);
                    return analytics
                }
            };
                
            for (var t=0;t<analytics.methods.length;t++) {
                var e = analytics.methods[t];
                analytics[e] = analytics.factory(e)
            }
            analytics.load = function(t,e) {
                var n = document.createElement("script");
                n.type = "text/javascript";
                n.async = !0;
                n.src = "https://cdn.segment.com/analytics.js/v1/"+t+"/analytics.min.js";
                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(n,a);
                analytics._loadOptions = e;
            };
            analytics.SNIPPET_VERSION = "4.1.0";
        };
        analytics.load("0AHoEduuheADwSq0PdnKHa68H88z1tFo");
        analytics.page();
    }
    if(window.skilljarUserSignupFields.sub===undefined || window.skilljarUserSignupFields.sub.value===undefined || window.skilljarUserSignupFields.sub.value==='') {
        analytics.identify(window.skilljarUser.id,{
            name: window.skilljarUser.name,
            email: window.skilljarUser.email});
    } else {
        analytics.identify(window.skilljarUserSignupFields.sub.value,{
            name: window.skilljarUser.name,
            email: window.skilljarUser.email});
    }
}();

/** Additional code for Segment tracking
 * => included manually in SkillJar Theme Settings
 * => included here for reference
 * 
 * Conversion Code Snippet:
 * => on course enrollment
 * 
 * if (typeof(skilljarCourse) !== 'undefined') {
 *  analytics.track('Course Registered',{
 *      'course_id':skilljarCourse.publishedCourseId,
 *      'course_title':skilljarCourse.title
 *  })};
 * 
 * 
 * Course Completion Code Snippet:
 * => on course completion
 * 
 * if (typeof(skilljarCourse) !== 'undefined') {
 *  analytics.track('Course Completed',{
 *      'course_id':skilljarCourse.publishedCourseId,
 *      'course_title':skilljarCourse.title
 *  })};
 */